import {useState} from 'react';
import type {ElementType, MouseEvent} from 'react';
import SimpleConfirmationDialog from "./SimpleConfirmationDialog";
import {DialogContentText, Typography} from "@mui/material";
import {removeAccountFundingSource} from "./user/request/user-requests";
import Busy from "./Busy";
import {getErrorMessage} from "../util/NetworkErrorUtil";
import {styled} from "@mui/material/styles";
import type {Account} from "../types/Account";

const MarginTop10 = styled(Typography)<{component?: ElementType}>(() => ({
  marginTop: '0.71rem',
}));

interface DialogBodyProps {
  errorMsg: string;
}

const DialogBody = ({errorMsg}: DialogBodyProps) => {
  return <>
    <DialogContentText component={'strong'}>
      Are you sure you would like to remove this payout account? Please make sure to replace or update your bank
      account on file in order to process any payout from Securspace going forward.
    </DialogContentText>
    {
      errorMsg &&
      <MarginTop10 variant="body1" component="div" color="error" align="center">
        {errorMsg}
      </MarginTop10>
    }
  </>
}

interface RemovePartnerFundingSourceDialogProps {
  account: Pick<Account, 'id'>;
  open: boolean;
  onClose: () => void;
  onSuccess: (responseBody: unknown) => void;
}

const RemovePartnerFundingSourceDialog = (props: RemovePartnerFundingSourceDialogProps) => {
  const {account, open, onClose, onSuccess} = props;
  const [errorMsg, setErrorMsg] = useState('');

  const resetDialog = () => {
    setErrorMsg('');
  }

  const handleClose = () => {
    resetDialog();
    onClose();
  };

  const handleConfirm = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const handleSuccess = (response: unknown) => {
      Busy.set(false);
      resetDialog();
      onSuccess(response);
    };
    const handleError = (error: unknown) => {
      Busy.set(false);
      setErrorMsg(getErrorMessage(error));
    };
    Busy.set(true);
    void removeAccountFundingSource(account.id, handleSuccess, handleError);
  };

  return (
    <SimpleConfirmationDialog
      onClose={handleClose}
      onConfirm={handleConfirm}
      open={open}
      title="Remove Payout Account"
      body={<DialogBody errorMsg={errorMsg}/>}
    />
  );
};

export default RemovePartnerFundingSourceDialog;
